// components/PreviewDrawer.tsx
import React from 'react';
import { Drawer } from '@mantine/core';
import { BuilderField } from '../types/BuilderField';
import { FormPreview } from '../FormPreview';

export interface PreviewDrawerProps {
  opened: boolean;
  onClose: () => void;
  fields: BuilderField[];
}

export function PreviewDrawer({ opened, onClose, fields }: PreviewDrawerProps) {
  return (
    <Drawer opened={opened} onClose={onClose} title="Preview" position="right" size="lg">
      <FormPreview fields={fields} />
    </Drawer>
  );
}